<script>
    export let api, selected;

    let searchinp = '', searchitems;
    function search() {
        let items = searchitems.children;
        for (const a of items) {
            if (a.getAttribute('data-search') == 'show' || a.getAttribute('data-placename').toUpperCase().indexOf(searchinp.toUpperCase()) > -1) {
                a.classList.remove('hidden');
            } else {
                a.classList.add('hidden');
            }
        };
    };
</script>

<div class="flex flex-col items-center justify-center w-full h-full overflow-hidden lg:flex-row shadow-elevate-lg rounded-2xl">
    <div class="relative z-50 flex flex-row items-center justify-between w-full h-full bg-white basis-2/3 grow shrink-0 shadow-elevate-lg">
        {#if selected != undefined && selected.PlaceName != undefined && selected.PlaceName != ''}
            <div class="flex flex-col items-center justify-start flex-none h-full p-2 px-4 text-left bg-gray-200 basis-1/4">
                <h3 class="mt-3 text-2xl font-semibold">Place Owners</h3>
                {#each selected.PlaceOwner.split(', ') as owner}
                    <div class="flex flex-row items-center justify-center w-full h-7">
                        <img src="https://mc-heads.net/avatar/{api.players.filter(a => a.PlayerUsername == owner)[0].PlayerUUID}.png" alt="{api.players.filter(a => a.PlayerUsername == owner)[0].PlayerNickname || api.players.filter(a => a.PlayerUsername == owner)[0].PlayerUsername}'s MC Face" class="h-full py-1 mr-2">
                        <p class="text-xl">{owner}</p>
                    </div>
                {/each}

                <h3 class="mt-3 text-2xl font-semibold">Place Location</h3>
                <a class="text-xl" href="http://phoenixcraft.serv.nu:10445/index.html?worldname=Phoenixcraft%20Season%206&amp;zoom=6&amp;x={selected.PlaceLocation.MainCoords[0]}y={selected.PlaceLocation.MainCoords[1]}&amp;z={selected.PlaceLocation.MainCoords[2]}" target="_blank">{selected.PlaceLocation.MainCoords.join(' / ')}</a>

                <h3 class="mt-3 text-2xl font-semibold">Portal Coordinates</h3>
                <h3 class="mt-1 text-xl font-medium">In Overworld:</h3>
                <a class="text-xl" href="http://phoenixcraft.serv.nu:10445/index.html?worldname=Phoenixcraft%20Season%206&amp;zoom=6&amp;x={selected.PlaceLocation.PortalCoords.Overworld[0]}y={selected.PlaceLocation.PortalCoords.Overworld[1]}&amp;z={selected.PlaceLocation.PortalCoords.Overworld[2]}" target="_blank">{selected.PlaceLocation.PortalCoords.Overworld.join(' / ')}</a>
                <h3 class="mt-2 text-xl font-medium">In The Nether:</h3>
                <a class="text-xl" href="http://phoenixcraft.serv.nu:10445/index.html?worldname=Phoenixcraft%20Season%206_nether&amp;zoom=6&amp;x={selected.PlaceLocation.PortalCoords.Nether[0]}y={selected.PlaceLocation.PortalCoords.Nether[1]}&amp;z={selected.PlaceLocation.PortalCoords.Nether[2]}" target="_blank">{selected.PlaceLocation.PortalCoords.Nether.join(' / ')}</a>
            
                <br class="flex-1">
                <a class="mt-2 text-xl font-medium" href="/navigator/{selected._id}">View in Navigator</a>
            </div>
            <div class="flex flex-col items-center justify-start flex-none h-full max-h-full p-2 overflow-auto basis-3/4">
                <img src={selected.PlaceImage || '/assets/img/Endport.png'} alt="Cover image for {selected.PlaceName}" class="w-full {selected.PlaceImage ? '' : 'aspect-video'}">
                <div class="flex flex-row items-center justify-center w-full p-3 bg-gray-200">
                    <h1 class="flex-1 text-3xl font-bold text-center">{selected.PlaceName}</h1>
                </div>
                <div class="flex flex-col items-center justify-start w-full h-full max-h-full gap-2 mt-2 overflow-auto">
                    <p class="text-xl">{selected.PlaceDescription}</p>
                    {#each selected.PlaceLocation.RoadLinks.filter(a => a.Type == 'Road') as item}
                        <div class="flex flex-row items-center justify-start w-full p-2 transition-colors duration-200 ease-in-out bg-gray-200 rounded-md h-11">
                            <img src={api.icons.Road} class="w-10 h-10 p-1 mr-2 bg-gray-200 rounded-md" alt="Road Icon">
                            <p class="flex-1">{item.Path}</p>
                            <a class="flex-1 text-right" href="http://phoenixcraft.serv.nu:10445/index.html?&amp;zoom=6&amp;x={item.Link[0]}y={item.Link[1]}&amp;z={item.Link[2]}" target="_blank">{item.Link.join(' / ')}</a>
                        </div>
                    {/each}
                    {#each selected.PlaceLocation.RailLinks as item}
                        <div class="flex flex-row items-center justify-start w-full p-2 transition-colors duration-200 ease-in-out bg-gray-200 rounded-md h-11">
                            <img src={api.icons.Rail} class="w-10 h-10 p-1 mr-2 bg-gray-200 rounded-md" alt="Rail Icon">
                            <p class="flex-1">{item.Path}</p>
                            <a class="flex-1 text-right" href="http://phoenixcraft.serv.nu:10445/index.html?&amp;zoom=6&amp;x={item.Link[0]}y={item.Link[1]}&amp;z={item.Link[2]}" target="_blank">{item.Link.join(' / ')}</a>
                        </div>
                    {/each}
                    {#each selected.PlaceLocation.RoadLinks.filter(a => a.Type == 'NetherTunnel') as item}
                        <div class="flex flex-row items-center justify-start w-full p-2 transition-colors duration-200 ease-in-out bg-gray-200 rounded-md h-11">
                            <img src={api.icons.Portal} class="w-10 h-10 p-1 mr-2 bg-gray-200 rounded-md" alt="Portal Icon">
                            <p class="flex-1">{item.Path}</p>
                            <a class="flex-1 text-right" href="http://phoenixcraft.serv.nu:10445/index.html?&amp;zoom=6&amp;x={item.Link[0]}y={item.Link[1]}&amp;z={item.Link[2]}" target="_blank">{item.Link.join(' / ')}</a>
                        </div>
                    {/each}
                </div>
            </div>
        {:else}
            <img src="/assets/img/S3Dynmap.jpg" alt="Season 3 City" class="absolute z-10 object-cover h-full lg:w-full scale-30 botton-0" style="filter: brightness(50%);">
            <h1 class="z-20 w-full text-6xl font-semibold text-center text-white">No Place Selected</h1>
        {/if}
    </div>
    <div class="flex flex-col items-center justify-start w-full h-full max-h-full gap-1 overflow-auto bg-gray-200 basis-1/3 grow shrink-0" bind:this={searchitems}>
        <div class="flex flex-col items-center justify-center w-full p-3 mb-2 bg-white cursor-pointer select-none" data-search="show">
            <h2 class="w-full text-lg font-light text-left">Search for a Place</h2>
            <input bind:value={searchinp} on:keyup={() => search()} on:contextmenu|preventDefault={() => { searchinp = ''; search() }} class="w-full p-1 text-xl font-semibold text-left border-b border-gray-400 bg-inherit">
        </div>
        {#each api.places.sort((a, b) => a.PlaceName > b.PlaceName ? 1 : -1) as place, i}
            <div class="flex flex-col items-center justify-center w-full p-3 bg-white cursor-pointer select-none hover:bg-gray-100" data-placename={place.PlaceName} on:click={() => { selected = place; history.pushState('', '', '/places/' + place._id); }}>
                <h2 class="w-full text-lg font-light text-left">{place.PlaceOwner}</h2>
                <h1 class="w-full text-xl font-semibold text-left">{place.PlaceName}</h1>
            </div>
        {:else}
            <p>Loading...</p>
        {/each}
    </div>
</div>

<style>
    a:hover {
        text-decoration: underline;
    }
</style>